<template>
  <vueSelect
    :options="resp.categorias"
    label="nombre"
    placeholder="Todas"
    @input="getCategoria"
  >
    <option key="0" value="Todas" />
    <template v-slot:no-options="{ search, searching }">
      <template v-if="searching">
        No se encontraron resultados para <em>{{ search }}</em
        >.
      </template>
      <em style="opacity: 0.5" v-else></em>
    </template>
  </vueSelect>
</template>

<script>
import axios from "axios";
import vueSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "SelectVue",
  components: {
    vueSelect,
  },
  data() {
    return {
      resp: [],
      idCategoria: null,
    };
  },
  created: function () {
    var that = this;
    axios
      .get("https://egobierno2.aguascalientes.gob.mx/moviles/eventos/api/Datos")
      .then(function (response) {
        that.resp = response.data;
      })
      .catch(function (error) {
        console.log("Error: " + error);
      });
  },
  methods: {
    getCategoria(item) {
      this.idCategoria = item !== null ? item.id : null;
      this.$emit("input", this.idCategoria);
    },
  },
};
</script>
